/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiAdminDtoExpiringCompanyDto } from './WebApiAdminDtoExpiringCompanyDto';
import {
    WebApiAdminDtoExpiringCompanyDtoFromJSON,
    WebApiAdminDtoExpiringCompanyDtoFromJSONTyped,
    WebApiAdminDtoExpiringCompanyDtoToJSON,
} from './WebApiAdminDtoExpiringCompanyDto';

/**
 * System-wide statistics
 * @export
 * @interface WebApiAdminDtoSystemOverviewDto
 */
export interface WebApiAdminDtoSystemOverviewDto {
    /**
     * Total number of companies in the system
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    totalCompanies?: number;
    /**
     * Number of companies with active subscriptions
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    activeCompanies?: number;
    /**
     * Total number of active users
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    totalUsers?: number;
    /**
     * Total number of members across all companies
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    totalMembers?: number;
    /**
     * New members created today
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    newMembersToday?: number;
    /**
     * New members created this week
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    newMembersThisWeek?: number;
    /**
     * Total events in the system
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    totalEvents?: number;
    /**
     * Events created today
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    eventsToday?: number;
    /**
     * Events created this week
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    eventsThisWeek?: number;
    /**
     * Number of Fortnox syncs today
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    fortnoxSyncsToday?: number;
    /**
     * Number of external payments from Fortnox
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    fortnoxPayments?: number;
    /**
     * Number of PingPayments payment links created
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    pingPaymentLinksCreated?: number;
    /**
     * Number of PingPayments transactions with PayDate set
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    pingPaymentTransactionsPaid?: number;
    /**
     * Number of PingPayments transactions with PayDate set today
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    pingPaymentTransactionsPaidToday?: number;
    /**
     * Number of PingPayments transactions with SettledAt set
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    pingPaymentTransactionsSettled?: number;
    /**
     * Number of PingPayments transactions with SettledAt set today
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    pingPaymentTransactionsSettledToday?: number;
    /**
     * Companies with subscription expiring within 2 months
     * @type {Array<WebApiAdminDtoExpiringCompanyDto>}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    companiesExpiringWithin2Months?: Array<WebApiAdminDtoExpiringCompanyDto> | null;
    /**
     * Count of companies per subscription level
     * @type {{ [key: string]: number; }}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    companiesBySubscriptionLevel?: { [key: string]: number; } | null;
    /**
     * Number of companies with Free subscription
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    freeCompanies?: number;
    /**
     * Number of companies with Basic subscription
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    basicCompanies?: number;
    /**
     * Number of companies with BasicPlus subscription
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    basicPlusCompanies?: number;
    /**
     * Number of companies with BasicAdvanced subscription
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    basicAdvancedCompanies?: number;
    /**
     * Number of companies with Premium subscription
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    premiumCompanies?: number;
    /**
     * Number of companies with Enterprise subscription
     * @type {number}
     * @memberof WebApiAdminDtoSystemOverviewDto
     */
    enterpriseCompanies?: number;
}

/**
 * Check if a given object implements the WebApiAdminDtoSystemOverviewDto interface.
 */
export function instanceOfWebApiAdminDtoSystemOverviewDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoSystemOverviewDtoFromJSON(json: any): WebApiAdminDtoSystemOverviewDto {
    return WebApiAdminDtoSystemOverviewDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoSystemOverviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoSystemOverviewDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCompanies': !exists(json, 'totalCompanies') ? undefined : json['totalCompanies'],
        'activeCompanies': !exists(json, 'activeCompanies') ? undefined : json['activeCompanies'],
        'totalUsers': !exists(json, 'totalUsers') ? undefined : json['totalUsers'],
        'totalMembers': !exists(json, 'totalMembers') ? undefined : json['totalMembers'],
        'newMembersToday': !exists(json, 'newMembersToday') ? undefined : json['newMembersToday'],
        'newMembersThisWeek': !exists(json, 'newMembersThisWeek') ? undefined : json['newMembersThisWeek'],
        'totalEvents': !exists(json, 'totalEvents') ? undefined : json['totalEvents'],
        'eventsToday': !exists(json, 'eventsToday') ? undefined : json['eventsToday'],
        'eventsThisWeek': !exists(json, 'eventsThisWeek') ? undefined : json['eventsThisWeek'],
        'fortnoxSyncsToday': !exists(json, 'fortnoxSyncsToday') ? undefined : json['fortnoxSyncsToday'],
        'fortnoxPayments': !exists(json, 'fortnoxPayments') ? undefined : json['fortnoxPayments'],
        'pingPaymentLinksCreated': !exists(json, 'pingPaymentLinksCreated') ? undefined : json['pingPaymentLinksCreated'],
        'pingPaymentTransactionsPaid': !exists(json, 'pingPaymentTransactionsPaid') ? undefined : json['pingPaymentTransactionsPaid'],
        'pingPaymentTransactionsPaidToday': !exists(json, 'pingPaymentTransactionsPaidToday') ? undefined : json['pingPaymentTransactionsPaidToday'],
        'pingPaymentTransactionsSettled': !exists(json, 'pingPaymentTransactionsSettled') ? undefined : json['pingPaymentTransactionsSettled'],
        'pingPaymentTransactionsSettledToday': !exists(json, 'pingPaymentTransactionsSettledToday') ? undefined : json['pingPaymentTransactionsSettledToday'],
        'companiesExpiringWithin2Months': !exists(json, 'companiesExpiringWithin2Months') ? undefined : (json['companiesExpiringWithin2Months'] === null ? null : (json['companiesExpiringWithin2Months'] as Array<any>).map(WebApiAdminDtoExpiringCompanyDtoFromJSON)),
        'companiesBySubscriptionLevel': !exists(json, 'companiesBySubscriptionLevel') ? undefined : json['companiesBySubscriptionLevel'],
        'freeCompanies': !exists(json, 'freeCompanies') ? undefined : json['freeCompanies'],
        'basicCompanies': !exists(json, 'basicCompanies') ? undefined : json['basicCompanies'],
        'basicPlusCompanies': !exists(json, 'basicPlusCompanies') ? undefined : json['basicPlusCompanies'],
        'basicAdvancedCompanies': !exists(json, 'basicAdvancedCompanies') ? undefined : json['basicAdvancedCompanies'],
        'premiumCompanies': !exists(json, 'premiumCompanies') ? undefined : json['premiumCompanies'],
        'enterpriseCompanies': !exists(json, 'enterpriseCompanies') ? undefined : json['enterpriseCompanies'],
    };
}

export function WebApiAdminDtoSystemOverviewDtoToJSON(value?: WebApiAdminDtoSystemOverviewDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCompanies': value.totalCompanies,
        'activeCompanies': value.activeCompanies,
        'totalUsers': value.totalUsers,
        'totalMembers': value.totalMembers,
        'newMembersToday': value.newMembersToday,
        'newMembersThisWeek': value.newMembersThisWeek,
        'totalEvents': value.totalEvents,
        'eventsToday': value.eventsToday,
        'eventsThisWeek': value.eventsThisWeek,
        'fortnoxSyncsToday': value.fortnoxSyncsToday,
        'fortnoxPayments': value.fortnoxPayments,
        'pingPaymentLinksCreated': value.pingPaymentLinksCreated,
        'pingPaymentTransactionsPaid': value.pingPaymentTransactionsPaid,
        'pingPaymentTransactionsPaidToday': value.pingPaymentTransactionsPaidToday,
        'pingPaymentTransactionsSettled': value.pingPaymentTransactionsSettled,
        'pingPaymentTransactionsSettledToday': value.pingPaymentTransactionsSettledToday,
        'companiesExpiringWithin2Months': value.companiesExpiringWithin2Months === undefined ? undefined : (value.companiesExpiringWithin2Months === null ? null : (value.companiesExpiringWithin2Months as Array<any>).map(WebApiAdminDtoExpiringCompanyDtoToJSON)),
        'companiesBySubscriptionLevel': value.companiesBySubscriptionLevel,
        'freeCompanies': value.freeCompanies,
        'basicCompanies': value.basicCompanies,
        'basicPlusCompanies': value.basicPlusCompanies,
        'basicAdvancedCompanies': value.basicAdvancedCompanies,
        'premiumCompanies': value.premiumCompanies,
        'enterpriseCompanies': value.enterpriseCompanies,
    };
}

